import React from 'react';
import { useForm } from 'react-final-form';

import {
  FFStudentContactNumberField,
  isFalsy,
} from '@leapfinance/frontend-commons';
import { type FFStudentContactNumberFieldProps } from '@leapfinance/frontend-commons/components/geebee/FFStudentContactNumberField';
import { GBTypography } from '@leapfinance/geebee-component-library';

import useCheckDuplicateStudent from '@/hooks/vas/useCheckDuplicateStudent';

import { isStudentExisting } from '../helpers';

import StudentAlreadyExistWarning from './StudentAlreadyExistWarning';

export type FFVASContactNumberFieldProps = Omit<
  FFStudentContactNumberFieldProps,
  'onRedirectToExistingStudent' | 'handlePhoneNumberValidation'
> & {
  isStudentCreateModeOn?: boolean;
  handlePhoneNumberValidation?: (value: string) => void;
  onRedirectToExistingStudent?: () => void;
  isStudentSelected?: boolean;
};

function FFVASContactNumberField(props: FFVASContactNumberFieldProps) {
  const { getState, change } = useForm();
  const values = getState()?.values;
  const errors = getState()?.errors;
  const countryCodeValue = (
    values?.[props?.countryCodeFieldProps?.name ?? ``] as any
  )?.value;
  const { handlePhoneNumberValidation, existingStudentData } =
    useCheckDuplicateStudent({
      countryCode: countryCodeValue,
      contactNumber: values?.[props?.phoneNumberFieldProps?.name ?? ``],
      // when no student selected then also show existing student warning
      skipDuplicateValidation: props.isStudentSelected,
      // reset and remove error callback
    });

  change(`existingDuplicateStudent`, existingStudentData?.data);

  return (
    <>
      <FFStudentContactNumberField
        {...props}
        formValues={values}
        existingStudentData={{
          data: {},
        }}
        handlePhoneNumberValidation={(value) => {
          if (props.isStudentCreateModeOn) {
            handlePhoneNumberValidation(
              value,
              (values?.countryCode as any)?.value,
            );
          }
        }}
        onRedirectToExistingStudent={() => {
          if (props.isStudentCreateModeOn) {
            window.open(
              `/profile/${existingStudentData?.data?.studentId}?key=PROFILE`,
              `_blank`,
            );
          }
        }}
        combinedLabel={
          <GBTypography variant="sh2Regular">Contact Number</GBTypography>
        }
        containerClassName={props.containerClassName ?? `mt-1`}
        countryCodeComponentProps={{
          size: `medium`,
          textInputProps: {
            className: `h-10 mt-1`,
            InputProps: {
              className: `h-10 w-[80px]`,
            },
            ...props?.countryCodeComponentProps?.textInputProps,
          },

          fullWidth: false,
        }}
        phoneNumberComponentProps={{
          InputProps: {
            className: `h-10 mt-1`,
            ...props?.phoneNumberComponentProps?.InputProps,
          },
          size: `medium`,
          fullWidth: true,
        }}
      />
      {isStudentExisting({
        existingDuplicateStudent: existingStudentData?.data,
      }) &&
      isFalsy(errors?.[props?.phoneNumberFieldProps?.name ?? ``]) &&
      props.isStudentCreateModeOn ? (
        <StudentAlreadyExistWarning />
      ) : null}
    </>
  );
}

export default FFVASContactNumberField;
